export default __webpack_public_path__ + "static/BrandonGrotesque-Regular-0ebf3a70f70fb1986843fd05dbc91739.woff2";